import React, { PropTypes } from 'react';
import { Checkbox, Toggle } from 'material-ui';
import R from 'ramda';

const Template = props => {
  const { updateNotification, notifications = {}, settings, label, isSubmenu, assetReceiving, allDirectChecked, allIndirectChecked, toggleAllDirect, toggleAllIndirect } = props;
  return (
    <div style={{ marginTop: isSubmenu ? '10px' : '20px' }}>
      <div className="flex-tc-sb" style={{ fontSize: isSubmenu ? '14px' : '20px', fontWeight: 400, margin: '4px 0 0 10px', paddingBottom: '12px' }}>
        {isSubmenu ? label : `${label} Settings`}
        {
          Boolean(assetReceiving && !isSubmenu) && (
            <div className="flex-tc-sb" style={{ minWidth: '286px', marginRight: '40px' }}>
              <div
                className="hint--top"
                aria-label="Direct messages are communications sent to your email address"
              >
                <Checkbox
                  label="Direct Messages"
                  labelPosition="left"
                  checked={allDirectChecked}
                  labelStyle={{ fontSize: '12px', width: '100px' }}
                  onCheck={toggleAllDirect}
                />
              </div>
              <div
                className="hint--top"
                aria-label="Indirect Messages are notifications that are sent as another user on your account has received a direct message"
              >
                <Checkbox
                  label="Indirect Messages"
                  labelPosition="left"
                  checked={allIndirectChecked}
                  labelStyle={{ fontSize: '12px', width: '110px' }}
                  style={{ marginLeft: '12px' }}
                  trackStyle={allIndirectChecked ? {} : { backgroundColor: '#ff9d9d' }}
                  onCheck={toggleAllIndirect}
                />
              </div>
            </div>
          )
        }
      </div>
      <div style={isSubmenu ? { marginLeft: '30px', borderTop: '1px solid #e6e9ec' } : { margin: '0 30px' }}>
        {
          settings.map((setting, i) => {
            // some fields' values are array: ['email'], weekly fields' value will be boolean
            if (setting.settings) {
              return (
                <Template
                  key={i}
                  updateNotification={updateNotification}
                  notifications={notifications}
                  settings={setting.settings}
                  label={setting.label}
                  assetReceiving={setting.assetReceiving}
                  isSubmenu
                />
              );
            }
            const value = R.path([setting.type, setting.key], notifications);
            const arrayValue = value || [];
            const isDirectChecked = !R.contains('noDirect', value || []);
            const isChecked = setting.isBool ? Boolean(value) : R.contains('email', arrayValue);
            return (
              <div key={i} style={{ borderBottom: '1px solid #e6e9ec', padding: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={setting.disabled ? { color: 'rgba(0, 0, 0, 0.24)' } : {}}>{setting.text}</div>
                <div className="hint--top" aria-label={(() => {
                  if (setting.disabled) return 'This setting is disabled';
                  return isChecked ? 'Turn off email notification' : 'Turn on email notification';
                })()}>
                  {R.call(R.cond([
                    [() => Boolean(setting.disabled), R.always(<Toggle disabled />)],
                    [() => assetReceiving, R.always(<div className="flex-center">
                      <Toggle
                        label="Direct Messages"
                        labelStyle={{ fontSize: '12px', width: '100px', visibility: 'hidden' }}
                        toggled={isDirectChecked}
                        thumbStyle={isDirectChecked ? {} : { backgroundColor: '#ffcccc' }}
                        trackStyle={isDirectChecked ? {} : { backgroundColor: '#ff9d9d' }}
                        onToggle={() => {
                          if (setting.isBool) updateNotification(setting.type, { [setting.key]: !isDirectChecked });
                          else {
                            updateNotification(setting.type, {
                              [setting.key]: isDirectChecked ? [...arrayValue, 'noDirect'] : arrayValue.filter(x => x !== 'noDirect'),
                            });
                          }
                        }}
                      />
                      <Toggle
                        label="Indirect Messages"
                        labelStyle={{ fontSize: '12px', width: '110px', visibility: 'hidden' }}
                        style={{ marginLeft: '12px' }}
                        toggled={isChecked}
                        thumbStyle={isChecked ? {} : { backgroundColor: '#ffcccc' }}
                        trackStyle={isChecked ? {} : { backgroundColor: '#ff9d9d' }}
                        onToggle={() => {
                          if (setting.isBool) updateNotification(setting.type, { [setting.key]: !isChecked });
                          else {
                            updateNotification(setting.type, {
                              [setting.key]: isChecked ? arrayValue.filter(x => x !== 'email') : [...arrayValue, 'email'],
                            });
                          }
                        }}
                      />
                    </div>)],
                    [R.T, R.always(
                      <Toggle
                        toggled={isChecked}
                        thumbStyle={isChecked ? {} : { backgroundColor: '#ffcccc' }}
                        trackStyle={isChecked ? {} : { backgroundColor: '#ff9d9d' }}
                        onToggle={() => {
                          if (setting.isBool) updateNotification(setting.type, { [setting.key]: !isChecked });
                          else updateNotification(setting.type, { [setting.key]: isChecked ? [] : ['email'] });
                        }}
                      />
                    )],
                  ]))}
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

Template.propTypes = {
  updateNotification: PropTypes.func,
  notifications: PropTypes.object,
  label: PropTypes.string,
  settings: PropTypes.array,
  type: PropTypes.string,
  isSubmenu: PropTypes.bool,
  assetReceiving: PropTypes.bool,
  allDirectChecked: PropTypes.bool,
  allIndirectChecked: PropTypes.bool,
  toggleAllDirect: PropTypes.func,
  toggleAllIndirect: PropTypes.func,
};

export default Template;



// WEBPACK FOOTER //
// ./src/app/components/settings/notifications/template.jsx